/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Onboarding_Ask_UsageInputs */



/**
* | output |
* | --- |
* | "What do you want to use oneAI for? Pick up to {max} - I'll tailor my suggestions to it." |
*
* @param {Onboarding_Ask_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ask_usage = /** @type {((inputs: Onboarding_Ask_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ask_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wofür möchtest du oneAI nutzen? Wähle bis zu ${i?.max} - ich richte meine Vorschläge danach aus.`)
	return /** @type {LocalizedString} */ (`What do you want to use oneAI for? Pick up to ${i?.max} - I'll tailor my suggestions to it.`)
});